import { Reveal, Eyebrow } from "./Reveal";

export default function About({ content }) {
  const paragraphs = content?.about_paragraphs ?? [];
  return (
    <section id="about" className="relative py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:gap-12 lg:px-10">
        <div className="relative lg:col-span-5">
          <Reveal>
            <div className="relative mx-auto w-4/5 max-w-sm lg:w-full">
              <div className="arch absolute -right-4 -top-4 h-full w-full border border-gild/50" />
              <div className="arch relative overflow-hidden bg-white p-2.5 shadow-[0_30px_60px_-24px_rgba(24,19,16,0.35)]">
                <img
                  data-testid="artist-portrait"
                  src="/artwork/artist-portrait.jpg"
                  alt="Saivi Rahul Joshi in her studio"
                  className="arch aspect-[5/8] w-full object-cover"
                />
              </div>
              <p className="mt-6 text-center font-mono text-[10px] uppercase tracking-[0.26em] text-sand">
                Saivi Rahul Joshi — Studio
              </p>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow>About the Artists</Eyebrow>
            <h2 className="mt-6 font-serif text-3xl tracking-tight text-ink sm:text-5xl lg:text-6xl">
              Meet Saivi Rahul Joshi
            </h2>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-clay sm:text-lg">
              {paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.18}>
            <blockquote className="relative mt-10 border-l-2 border-gild pl-6 sm:pl-8">
              <p className="font-serif text-xl italic leading-snug text-ink sm:text-2xl">
                “{content?.quote}”
              </p>
            </blockquote>
          </Reveal>

          <Reveal delay={0.25}>
            <div className="mt-12 grid grid-cols-1 gap-6 border-t border-linen pt-8 sm:grid-cols-2">
              {[
                ["Medium", "Oil & Acrylic · Sketching · Mixed Media"],
                ["Subjects", "Portraits · Nature · Still Life"],
                ["Custom", "Photographs or image"],
                ["Education", "BVA — SMRK College, Nashik · GVD — Arena Animation, Nashik"],
              ].map(([k, v]) => (
                <div key={k}>
                  <p className="font-mono text-[10px] uppercase tracking-[0.26em] text-vermilion">{k}</p>
                  <p className="mt-2 font-serif text-lg text-ink">{v}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
